import { render } from "./Variant_GeneExpression.vue?vue&type=template&id=f0567f72"
import script from "./Variant_GeneExpression.vue?vue&type=script&lang=js"
export * from "./Variant_GeneExpression.vue?vue&type=script&lang=js"

import "./Variant_GeneExpression.vue?vue&type=style&index=0&id=f0567f72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__